const getApiUrl = () => {
    const hostname = window.location.hostname;
    if (hostname === 'mecbp.innovanetworking.com') {
        return 'https://mecbp.innovanetworking.com/api/';
    }
    return 'https://portal.mecbp.com/api/';
};

const API_URL_BASE = getApiUrl();

export default API_URL_BASE;


// const API_URL_BASE = "https://portal.mecbp.com/api/";
// const API_URL_BASE = "http://127.0.0.1:8000/api/";
// const API_URL_BASE = "http://mec-backend.test/api/";

// export default API_URL_BASE;